<template lang="pug">
v-card-text
  v-select(
    :value="location"
    @input="$emit('update:location', $event)"
    :items="formattedLocations"
    item-text="textToShow"
    item-value="id"
    label="Course configuration"
  )
</template>

<script>
import {mapGetters} from "vuex"

export default {
  props: {
    location: {
      type: Number
    }
  },
  computed: {
    ...mapGetters({
      locations: 'locationConfigurations/items'
    }),
    formattedLocations() {
      if(!this.locations) return []
      return [{name: 'Unselect', id: null}, ...this.locations].map(location => {
        return {
          ...location,
          textToShow: `${location.name}`
        }

      })
    }
  }
}
</script>